export default "__VITE_ASSET__DO2vu8rp__"